export const MAINTENANCE_CONF = {
    title: 'Improvements Coming Soon!',
    message: "We're working to upgrade your experience! Our site is currently under maintenance and will be back online shortly. We appreciate your patience."
};